import { Slice } from 'gatsby';
import React, { type FC } from 'react';

import { Logo } from '@/components/icons/logo';

export const Footer: FC = () => {
    return (
        <footer className="mt-72 container">
            <Logo theme="secondary" />

            <Slice allowEmpty alias="footer-extra" />
        </footer>
    );
};
